// tslint:disable
import { createRpcInvoker } from "cooke-rpc";

import { Email } from "../types";
import { Password } from "../types";

export enum ChangeEmailErrorCode {
  CodeCorrelationTokenError = "CodeCorrelationTokenError",
  IncorrectCode = "IncorrectCode",
  TooManyCodeAttempts = "TooManyCodeAttempts",
  AlreadyUsed = "AlreadyUsed"
}

export enum ChangeEmailStartErrorCode {
  IncorrectPassword = "IncorrectPassword",
  TooManyPasswordAttempts = "TooManyPasswordAttempts"
}

export enum ChangePasswordErrorCode {
  IncorrectPassword = "IncorrectPassword",
  InsufficientPassword = "InsufficientPassword",
  TooManyPasswordAttempts = "TooManyPasswordAttempts"
}

export enum License {
  Individual = "Individual",
  Group2 = "Group2",
  Group5 = "Group5",
  Group100 = "Group100"
}

export enum LoginFailedCode {
  InvalidCredentials = "InvalidCredentials",
  LockedOut = "LockedOut",
  NoValidLicense = "NoValidLicense",
  UsageExceeded = "UsageExceeded"
}

export enum OrderStatus {
  Created = "Created",
  Paid = "Paid",
  Cancelled = "Cancelled",
  Declined = "Declined",
  Error = "Error"
}

export enum ProcessOrderResult {
  Processing = "Processing",
  Paid = "Paid",
  Error = "Error",
  Cancelled = "Cancelled",
  Declined = "Declined"
}

export enum RegisterErrorCode {
  CodeCorrelationTokenError = "CodeCorrelationTokenError",
  TooManyCodeAttempts = "TooManyCodeAttempts",
  IncorrectCode = "IncorrectCode",
  AlreadyUsed = "AlreadyUsed"
}

export enum RemoveAccountResult {
  Removed = "Removed",
  IncorrectPassword = "IncorrectPassword",
  TooManyPasswordAttempts = "TooManyPasswordAttempts"
}

export enum ResetPasswordErrorCode {
  BindingTokenError = "BindingTokenError",
  IncorrectCode = "IncorrectCode",
  AlreadyUsed = "AlreadyUsed",
  TooManyAttempts = "TooManyAttempts",
  UserNotFound = "UserNotFound"
}

export enum VerifyPasswordResetCodeResult {
  BindingTokenError = "BindingTokenError",
  IncorrectCode = "IncorrectCode",
  Ok = "Ok",
  AlreadyUsed = "AlreadyUsed",
  TooManyAttempts = "TooManyAttempts"
}

export interface AccountData {
  $type?: "AccountData";
  accessUntil: string;
  email?: null | Email;
  id: number;
  payments: Array<Order>;
}

export interface AdminWord {
  $type?: "AdminWord";
  examples: Array<AdminWordExample>;
  explanation: string;
  hasImage: boolean;
  id: string;
  name: string;
}

export interface AdminWordExample {
  $type?: "AdminWordExample";
  content: string;
  id: number;
  name: string;
}

export interface AdminWordListItem {
  $type?: "AdminWordListItem";
  hasImage: boolean;
  id: string;
  name: string;
}

export interface ChangeEmailErrorResult extends ChangeEmailResult$Base {
  $type: "ChangeEmailErrorResult";
  code: ChangeEmailErrorCode;
}

export interface ChangeEmailInput {
  $type?: "ChangeEmailInput";
  code: string;
  correlationToken: string;
}

export interface ChangeEmailResult$Base {

}

export type ChangeEmailResult = ChangeEmailErrorResult | ChangeEmailSuccessResult;

export interface ChangeEmailStartError extends ChangeEmailStartResult$Base {
  $type: "ChangeEmailStartError";
  code: ChangeEmailStartErrorCode;
}

export interface ChangeEmailStartInput {
  $type?: "ChangeEmailStartInput";
  newEmail: Email;
  password: string;
}

export interface ChangeEmailStartResult$Base {

}

export type ChangeEmailStartResult = ChangeEmailStartError | ChangeEmailStartSuccess;

export interface ChangeEmailStartSuccess extends ChangeEmailStartResult$Base {
  $type: "ChangeEmailStartSuccess";
  correlationToken: string;
}

export interface ChangeEmailSuccessResult extends ChangeEmailResult$Base {
  $type: "ChangeEmailSuccessResult";

}

export interface ChangePasswordError extends ChangePasswordResult$Base {
  $type: "ChangePasswordError";
  code: ChangePasswordErrorCode;
}

export interface ChangePasswordResult$Base {

}

export type ChangePasswordResult = ChangePasswordError | ChangePasswordSuccess;

export interface ChangePasswordSuccess extends ChangePasswordResult$Base {
  $type: "ChangePasswordSuccess";

}

export interface ConfirmOrderInput {
  $type?: "ConfirmOrderInput";
  sessionId: string;
}

export interface CreateInput {
  $type?: "CreateInput";
  name: string;
}

export interface CreateWordInput {
  $type?: "CreateWordInput";
  id: string;
  word: string;
}

export interface CreateWordListInput {
  $type?: "CreateWordListInput";
  name: string;
}

export interface CryptoRandom {
  $type?: "CryptoRandom";
  code: string;
  id: number;
  username: string;
}

export interface FetchSessionResult$Base {

}

export type FetchSessionResult = NoSessionResult | SessionResult;

export interface GroupAccountSessionData extends SessionData$Base {
  $type: "GroupAccountSessionData";
  accessUntil: string;
  groupAccountId: number;
  subject: string;
}

export interface InitiateOrderResponse {
  $type?: "InitiateOrderResponse";
  checkoutUrl: string;
}

export interface ListOrder {
  $type?: "ListOrder";
  amount: number;
  createdAt: string;
  id: string;
  status: OrderStatus;
  stripePaymentIntentId?: null | string;
  updatedAt?: null | null | string;
  userEmail?: null | string;
  userId?: null | null | number;
}

export interface ListSession {
  $type?: "ListSession";
  createdAt: string;
  id: number;
  lastActivity: string;
  user: SessionUserOrGroupAccount;
}

export interface ListUser {
  $type?: "ListUser";
  accessUntil: string;
  createdAt: string;
  email?: null | string;
  id: number;
  lastLogin: string;
}

export interface LoginFailed extends LoginResult$Base {
  $type: "LoginFailed";
  code: LoginFailedCode;
}

export interface LoginResult$Base {

}

export type LoginResult = LoginFailed | LoginSuccess;

export interface LoginSuccess extends LoginResult$Base {
  $type: "LoginSuccess";
  sessionData: SessionData;
}

export interface Member {
  $type?: "Member";
  createdAt: string;
  email: Email;
  userId?: null | null | number;
}

export interface NoSessionResult extends FetchSessionResult$Base {
  $type: "NoSessionResult";

}

export interface Order {
  $type?: "Order";
  createdAt: string;
  id: string;
  status: OrderStatus;
  total: number;
  userReference?: null | string;
  vat: number;
  vatPercent: number;
}

export interface Organization {
  $type?: "Organization";
  email?: null | Email;
  groupAccounts: Array<CryptoRandom>;
  id: string;
  license?: null | License;
  licenseUntil: string;
  members: Array<Member>;
  name: string;
  numberOfSessions: number;
}

export interface OrganizationListItem {
  $type?: "OrganizationListItem";
  id: string;
  license?: null | License;
  licenseUntil: string;
  name: string;
}

export interface RegisterError extends RegisterResponse$Base {
  $type: "RegisterError";
  code: RegisterErrorCode;
}

export interface RegisterInput {
  $type?: "RegisterInput";
  code: string;
  codeCorrelationToken: string;
}

export interface RegisterResponse$Base {

}

export type RegisterResponse = RegisterError | RegisterSuccess;

export interface RegisterStartInput {
  $type?: "RegisterStartInput";
  email: Email;
  password: Password;
}

export interface RegisterStartResult {
  $type?: "RegisterStartResult";
  correlationToken: string;
}

export interface RegisterSuccess extends RegisterResponse$Base {
  $type: "RegisterSuccess";
  sessionData: SessionData;
}

export interface ReportFeedbackInput {
  $type?: "ReportFeedbackInput";
  feedback: string;
}

export interface ReportPageVisitInput {
  $type?: "ReportPageVisitInput";
  appInstanceId: string;
  path: string;
}

export interface RequestPasswordResetResult {
  $type?: "RequestPasswordResetResult";
  correlationToken: string;
}

export interface ResetPasswordError extends ResetPasswordResult$Base {
  $type: "ResetPasswordError";
  code: ResetPasswordErrorCode;
}

export interface ResetPasswordResult$Base {

}

export type ResetPasswordResult = ResetPasswordError | ResetPasswordSuccess;

export interface ResetPasswordSuccess extends ResetPasswordResult$Base {
  $type: "ResetPasswordSuccess";
  sessionData: SessionData;
}

export interface SessionData$Base {
  accessUntil: string;
  subject: string;
}

export type SessionData = GroupAccountSessionData | UserSessionData;

export interface SessionGroupAccount extends SessionUserOrGroupAccount$Base {
  $type: "SessionGroupAccount";
  id: number;
  organizationId: string;
  organizationName: string;
}

export interface SessionResult extends FetchSessionResult$Base {
  $type: "SessionResult";
  data: SessionData;
}

export interface SessionUser extends SessionUserOrGroupAccount$Base {
  $type: "SessionUser";
  email?: null | Email;
  id: number;
}

export interface SessionUserOrGroupAccount$Base {

}

export type SessionUserOrGroupAccount = SessionGroupAccount | SessionUser;

export interface UpdateInput {
  $type?: "UpdateInput";
  email?: Email | undefined;
  license?: License | undefined;
  licenseUntil?: string | undefined;
  name?: string | undefined;
  organizationNumber?: string | undefined;
}

export interface UpdateUserInput {
  $type?: "UpdateUserInput";
  accessUntil?: string | undefined;
  email?: Email | undefined;
  isAdmin?: boolean | undefined;
}

export interface UpdateWordListInput {
  $type?: "UpdateWordListInput";
  name: string;
}

export interface User {
  $type?: "User";
  accessUntil: string;
  createdAt: string;
  email?: null | string;
  failedPasswordAttempts: number;
  id: number;
  isAdmin: boolean;
  lastLogin: string;
  memberships: Array<UserMembership>;
  orders: Array<UserOrder>;
  userPasswordLockoutAt?: null | null | string;
}

export interface UserMembership {
  $type?: "UserMembership";
  id: string;
  name: string;
}

export interface UserOrder {
  $type?: "UserOrder";
  amount: number;
  createdAt: string;
  id: string;
  status: OrderStatus;
  stripePaymentIntentId?: null | string;
  updatedAt?: null | null | string;
}

export interface UserSessionData extends SessionData$Base {
  $type: "UserSessionData";
  accessUntil: string;
  subject: string;
  userId: number;
}

export interface Word {
  $type?: "Word";
  examples: Array<WordExample>;
  explanation: string;
  hasImage: boolean;
  id: string;
  name: string;
}

export interface WordExample {
  $type?: "WordExample";
  name: string;
  text: string;
}

export interface WordExampleInput {
  $type?: "WordExampleInput";
  content: string;
  name: string;
}

export interface WordListDetail {
  $type?: "WordListDetail";
  createdAt: string;
  id: string;
  isOrganizationOwned: boolean;
  name: string;
  words: Array<WordListWord>;
}

export interface WordListItem {
  $type?: "WordListItem";
  id: string;
  name: string;
}

export interface WordListSummary {
  $type?: "WordListSummary";
  createdAt: string;
  id: string;
  isOrganizationOwned: boolean;
  name: string;
}

export interface WordListWord {
  $type?: "WordListWord";
  id: string;
  name: string;
}

export const accountController = {
  fetch: createRpcInvoker<'AccountController', 'Fetch', [], AccountData>('AccountController', 'Fetch'),
  changeEmailStart: createRpcInvoker<'AccountController', 'ChangeEmailStart', [input: ChangeEmailStartInput], ChangeEmailStartResult>('AccountController', 'ChangeEmailStart'),
  changeEmail: createRpcInvoker<'AccountController', 'ChangeEmail', [input: ChangeEmailInput], ChangeEmailResult>('AccountController', 'ChangeEmail'),
  changePassword: createRpcInvoker<'AccountController', 'ChangePassword', [currentPassword: string, newPassword: Password], ChangePasswordResult>('AccountController', 'ChangePassword'),
  removeAccount: createRpcInvoker<'AccountController', 'RemoveAccount', [password: string, reason: string], RemoveAccountResult>('AccountController', 'RemoveAccount'),
}

export const adminOrderController = {
  getOrders: createRpcInvoker<'AdminOrderController', 'GetOrders', [], Array<ListOrder>>('AdminOrderController', 'GetOrders'),
}

export const adminOrganizationController = {
  getAll: createRpcInvoker<'AdminOrganizationController', 'GetAll', [], Array<OrganizationListItem>>('AdminOrganizationController', 'GetAll'),
  get: createRpcInvoker<'AdminOrganizationController', 'Get', [id: string], Organization>('AdminOrganizationController', 'Get'),
  delete: createRpcInvoker<'AdminOrganizationController', 'Delete', [id: string], void>('AdminOrganizationController', 'Delete'),
  create: createRpcInvoker<'AdminOrganizationController', 'Create', [input: CreateInput], string>('AdminOrganizationController', 'Create'),
  update: createRpcInvoker<'AdminOrganizationController', 'Update', [id: string, input: UpdateInput], void>('AdminOrganizationController', 'Update'),
  addMember: createRpcInvoker<'AdminOrganizationController', 'AddMember', [id: string, email: Email], void>('AdminOrganizationController', 'AddMember'),
  removeMember: createRpcInvoker<'AdminOrganizationController', 'RemoveMember', [id: string, email: Email], void>('AdminOrganizationController', 'RemoveMember'),
  createGroupAccount: createRpcInvoker<'AdminOrganizationController', 'CreateGroupAccount', [organizationId: string], void>('AdminOrganizationController', 'CreateGroupAccount'),
  deleteGroupAccount: createRpcInvoker<'AdminOrganizationController', 'DeleteGroupAccount', [groupAccountId: number], void>('AdminOrganizationController', 'DeleteGroupAccount'),
}

export const adminSessionController = {
  getSessions: createRpcInvoker<'AdminSessionController', 'GetSessions', [], Array<ListSession>>('AdminSessionController', 'GetSessions'),
  deleteSession: createRpcInvoker<'AdminSessionController', 'DeleteSession', [id: number], void>('AdminSessionController', 'DeleteSession'),
}

export const adminUserController = {
  getUsers: createRpcInvoker<'AdminUserController', 'GetUsers', [], Array<ListUser>>('AdminUserController', 'GetUsers'),
  getUser: createRpcInvoker<'AdminUserController', 'GetUser', [id: number], null | User>('AdminUserController', 'GetUser'),
  updateUser: createRpcInvoker<'AdminUserController', 'UpdateUser', [id: number, input: UpdateUserInput], void>('AdminUserController', 'UpdateUser'),
  delete: createRpcInvoker<'AdminUserController', 'Delete', [id: number], void>('AdminUserController', 'Delete'),
}

export const adminWordController = {
  getWordList: createRpcInvoker<'AdminWordController', 'GetWordList', [], Array<AdminWordListItem>>('AdminWordController', 'GetWordList'),
  getWord: createRpcInvoker<'AdminWordController', 'GetWord', [id: string], null | AdminWord>('AdminWordController', 'GetWord'),
  createWord: createRpcInvoker<'AdminWordController', 'CreateWord', [input: CreateWordInput], void>('AdminWordController', 'CreateWord'),
  updateWord: createRpcInvoker<'AdminWordController', 'UpdateWord', [wordId: string, explanation: string], void>('AdminWordController', 'UpdateWord'),
  createWordExample: createRpcInvoker<'AdminWordController', 'CreateWordExample', [wordId: string], number>('AdminWordController', 'CreateWordExample'),
  updateWordExample: createRpcInvoker<'AdminWordController', 'UpdateWordExample', [exampleId: number, input: WordExampleInput], void>('AdminWordController', 'UpdateWordExample'),
  removeWord: createRpcInvoker<'AdminWordController', 'RemoveWord', [wordId: string], void>('AdminWordController', 'RemoveWord'),
  removeWordExample: createRpcInvoker<'AdminWordController', 'RemoveWordExample', [exampleId: number], void>('AdminWordController', 'RemoveWordExample'),
}

export const groupLicenseOrderController = {
}

export const orderController = {
  initiateOrder: createRpcInvoker<'OrderController', 'InitiateOrder', [], InitiateOrderResponse>('OrderController', 'InitiateOrder'),
  confirmOrder: createRpcInvoker<'OrderController', 'ConfirmOrder', [input: ConfirmOrderInput], ProcessOrderResult>('OrderController', 'ConfirmOrder'),
}

export const reportController = {
  reportPageVisit: createRpcInvoker<'ReportController', 'ReportPageVisit', [payload: ReportPageVisitInput], void>('ReportController', 'ReportPageVisit'),
  reportFeedback: createRpcInvoker<'ReportController', 'ReportFeedback', [payload: ReportFeedbackInput], void>('ReportController', 'ReportFeedback'),
}

export const sessionController = {
  fetchSession: createRpcInvoker<'SessionController', 'FetchSession', [], FetchSessionResult>('SessionController', 'FetchSession'),
  logout: createRpcInvoker<'SessionController', 'Logout', [], void>('SessionController', 'Logout'),
  requestPasswordReset: createRpcInvoker<'SessionController', 'RequestPasswordReset', [email: Email], RequestPasswordResetResult>('SessionController', 'RequestPasswordReset'),
  verifyPasswordResetCode: createRpcInvoker<'SessionController', 'VerifyPasswordResetCode', [bindingToken: string, code: string], VerifyPasswordResetCodeResult>('SessionController', 'VerifyPasswordResetCode'),
  resetPassword: createRpcInvoker<'SessionController', 'ResetPassword', [correlationToken: string, code: string, newPassword: Password], ResetPasswordResult>('SessionController', 'ResetPassword'),
  login: createRpcInvoker<'SessionController', 'Login', [username: string, password: string], LoginResult>('SessionController', 'Login'),
  registerStart: createRpcInvoker<'SessionController', 'RegisterStart', [input: RegisterStartInput], RegisterStartResult>('SessionController', 'RegisterStart'),
  register: createRpcInvoker<'SessionController', 'Register', [input: RegisterInput], RegisterResponse>('SessionController', 'Register'),
}

export const wordController = {
  getWordList: createRpcInvoker<'WordController', 'GetWordList', [], Array<WordListItem>>('WordController', 'GetWordList'),
  getWord: createRpcInvoker<'WordController', 'GetWord', [id: string], null | Word>('WordController', 'GetWord'),
}

export const wordListController = {
  getWordLists: createRpcInvoker<'WordListController', 'GetWordLists', [], Array<WordListSummary>>('WordListController', 'GetWordLists'),
  getWordList: createRpcInvoker<'WordListController', 'GetWordList', [id: string], null | WordListDetail>('WordListController', 'GetWordList'),
  createWordList: createRpcInvoker<'WordListController', 'CreateWordList', [input: CreateWordListInput], null | WordListSummary>('WordListController', 'CreateWordList'),
  updateWordList: createRpcInvoker<'WordListController', 'UpdateWordList', [id: string, input: UpdateWordListInput], null | WordListSummary>('WordListController', 'UpdateWordList'),
  deleteWordList: createRpcInvoker<'WordListController', 'DeleteWordList', [id: string], boolean>('WordListController', 'DeleteWordList'),
  addWord: createRpcInvoker<'WordListController', 'AddWord', [listId: string, wordId: string], boolean>('WordListController', 'AddWord'),
  removeWord: createRpcInvoker<'WordListController', 'RemoveWord', [listId: string, wordId: string], boolean>('WordListController', 'RemoveWord'),
}

